import LinkSetupStepIcon from './link-setup-step-icon.jsx';
import PropTypes from 'prop-types';

LinkSetupStep.propTypes = {
  children: PropTypes.node,
  step: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  stepRef: PropTypes.func,
};

export default function LinkSetupStep({
  children,
  step,
  currentStep,
  title,
  stepRef,
}) {
  return (
    <div
      className={`collapse bg-neutral-50 border-neutral-100 shadow-sm bordered border-2 mb-4 ${currentStep < step ? 'collapse-close bg-neutral-0 shadow-base-100 border-neutral-50' : 'collapse-open'}`}
    >
      <input
        type="radio"
        name={`link-setup-step-${step}`}
        defaultChecked={currentStep >= step}
        ref={stepRef}
      />
      <div
        className={`collapse-title text-sm md:text-xl font-medium flex items-center ${currentStep < step ? 'text-neutral-300' : ''}`}
      >
        <LinkSetupStepIcon currentStep={currentStep} step={step} />
        <span>{title}</span>
      </div>
      <div className="collapse-content">{children}</div>
    </div>
  );
}
